import { render, staticRenderFns } from "./material_archivos.vue?vue&type=template&id=085e3ecc"
import script from "./material_archivos.vue?vue&type=script&lang=js"
export * from "./material_archivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports